<template>
  <q-layout>
    <router-view />
  </q-layout>
</template>